// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/me/feedback/:token\",\"regex\":\"^/me/feedback/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/me/moveon/:token\",\"regex\":\"^/me/moveon/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/authe\"},{\"path\":\"/autho\"},{\"path\":\"/ui\"},{\"path\":\"/admin\"},{\"path\":\"/backlog\"},{\"path\":\"/byebye\"},{\"path\":\"/initialize-account\"},{\"path\":\"/oauth/consent\"},{\"path\":\"/studio\"},{\"path\":\"/tutorial\"},{\"path\":\"/tutorial/concepts\"},{\"path\":\"/unauthorized\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/\"},{\"path\":\"/background\"},{\"path\":\"/contact\"},{\"path\":\"/faq\"},{\"path\":\"/labs/matrix\"},{\"path\":\"/link/agent\"},{\"path\":\"/product\"},{\"path\":\"/technology\"},{\"path\":\"/error\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Sets FastAPI URL for tracing depending on the environment, use production URL as fallback
  tracePropagationTargets: [process.env.NEXT_PUBLIC_FASTAPI_URL as string],

  //////* My additional options
  // Track the environment
  environment: process.env.NODE_ENV,

  // Disable tracking in dev (not needed)
  enabled: process.env.NODE_ENV !== "development",
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
